import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import * as Styled from './styled';
import { constants } from 'utils';

export default function FAQs() {
  return (
    <>
      <Text.Heading.H3 style={{ fontWeight: 600 }}>Who can apply?</Text.Heading.H3>
      <Text.Body>
        ​Victorian residents over the age of 18 are eligible to apply. Each household is limited to
        one Melbourne voucher each for the entire scheme.
      </Text.Body>
      <Text.Body>
        You must spend at least two consecutive nights in paid accommodation in any of the 26 local
        government areas in metropolitan Melbourne. This excludes areas already covered by the
        Regional Travel Voucher Scheme including the Yarra Valley, Dandenong Ranges, Frankston and
        the Mornington Peninsula. Click{' '}
        <Text.Link href={constants.externalLinks.eligibleLGAs} value='here' target='_blank' /> to
        view the list of eligible LGAs.
      </Text.Body>

      <Styled.Spacer24 />
      <Text.Heading.H3 style={{ fontWeight: 600 }}>What are the travel dates?</Text.Heading.H3>
      <Text.Body>
        The voucher release is for travel from {constants.contentDates.travelPeriodStart} to{' '}
        {constants.contentDates.travelPeriodEnd} 2021.
      </Text.Body>
      <Text.Body>
        You can submit your claim for your $200 voucher from {constants.contentDates.claimStart} to{' '}
        {constants.contentDates.claimDealine}.
      </Text.Body>
      <Text.Body>
        The link to claim your $200 voucher will be sent to you by email progressively in the week
        commencing {constants.contentDates.claimStart} 2021.
      </Text.Body>

      <Styled.Spacer24 />
      <Text.Heading.H3 style={{ fontWeight: 600 }}>What can I use the money for?</Text.Heading.H3>
      <Text.Body>
        You must spend at least two consecutive nights in paid accommodation in any of the 26 local
        government areas in metropolitan Melbourne. Other eligible expenses include tourism
        attractions, paid tours or experiences in metropolitan Melbourne.
      </Text.Body>

      <Styled.Spacer24 />
      <Text.Heading.H3 style={{ fontWeight: 600 }}>
        What can&apos;t I use the money for?
      </Text.Heading.H3>
      <Text.Body>
        You can&apos;t use it for gaming, alcohol (unless it&apos;s part of a tour or experience),
        transport or fuel, food and drinks (unless it&apos;s in a booked tourism product), groceries
        or personal items.
      </Text.Body>

      <Styled.Spacer24 />
      <Text.Heading.H3 style={{ fontWeight: 600 }}>Can I claim for less than $200?</Text.Heading.H3>
      <Text.Body>
        No. The vouchers are fixed at $200, and you must spend at least $400 on eligible expenses.
      </Text.Body>

      <Styled.Spacer24 />
      <Styled.TextBodyWithInlineLink>
        For more frequently asked questions,{' '}
        <Text.Link
          value='see here'
          href={constants.externalLinks.metroVoucherSchemeFaqs}
          target='_blank'
          showExtraLink></Text.Link>
      </Styled.TextBodyWithInlineLink>
    </>
  );
}
